import { PageHeading } from "@/components/Layout/Parts";
import Text from "@/components/Text";
import Results from "./components/Results";

const ImagesLibrary = () => {
  return (
    <>
      <Text $type="caption" $color="gray">
        BORED PANDA
      </Text>
      <PageHeading>Image Library</PageHeading>
      <Results />
    </>
  );
};

export default ImagesLibrary;
